import {
  PROGRESSIVE_DISCOUNTS_SET,
  PROGRESSIVE_DISCOUNT_EDIT_SET,
  PROGRESSIVE_DISCOUNT_LOADING,
  PROGRESSIVE_DISCOUNT_LOADED,
  PROGRESSIVE_DISCOUNT_CLEAR,
  PROGRESSIVE_DISCOUNT_TYPES_SET,
  PROGRESSIVE_DISCOUNT_TYPES_LOADING,
  PROGRESSIVE_DISCOUNT_TYPES_LOADED,
} from '../actionTypes';

const initialState = {
  discounts: [],
  discountEdit: null,
  discountIsLoading: false,
  discountTypes: [],
  discountTypesIsLoading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PROGRESSIVE_DISCOUNTS_SET:
      return {
        ...state,
        discounts: action.payload,
      };
    case PROGRESSIVE_DISCOUNT_EDIT_SET:
      return {
        ...state,
        discountEdit: action.payload,
      };
    case PROGRESSIVE_DISCOUNT_LOADING:
      return {
        ...state,
        discountIsLoading: true,
      };
    case PROGRESSIVE_DISCOUNT_LOADED:
      return {
        ...state,
        discountIsLoading: false,
      };
    case PROGRESSIVE_DISCOUNT_CLEAR:
      return {
        ...state,
        discounts: [],
        discountIsLoading: false,
        discountEdit: null,
      };
    case PROGRESSIVE_DISCOUNT_TYPES_SET:
      return {
        ...state,
        discountTypes: action.payload,
      };
    case PROGRESSIVE_DISCOUNT_TYPES_LOADING:
      return {
        ...state,
        discountTypesIsLoading: true,
      };
    case PROGRESSIVE_DISCOUNT_TYPES_LOADED:
      return {
        ...state,
        discountTypesIsLoading: false,
      };
    default:
      return state;
  }
};

export default reducer;
